module.exports = __webpack_public_path__ + "img/timelapse_desktop_poster.6c37390.jpg";